import { render, staticRenderFns } from "./projectOverview.vue?vue&type=template&id=1c91d06b&scoped=true"
import script from "./projectOverview.vue?vue&type=script&lang=js"
export * from "./projectOverview.vue?vue&type=script&lang=js"
import style0 from "./projectOverview.vue?vue&type=style&index=0&id=1c91d06b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c91d06b",
  null
  
)

export default component.exports